import { render, staticRenderFns } from "./Rastreabilidade.vue?vue&type=template&id=064e98a6&scoped=true&lang=pug"
import script from "./Rastreabilidade.vue?vue&type=script&lang=js"
export * from "./Rastreabilidade.vue?vue&type=script&lang=js"
import style0 from "./Rastreabilidade.vue?vue&type=style&index=0&id=064e98a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064e98a6",
  null
  
)

export default component.exports